import { render } from "./detail.vue?vue&type=template&id=fee35ef8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=fee35ef8&lang=scss"
import "./detail.vue?vue&type=style&index=1&id=fee35ef8&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee35ef8"]])

export default __exports__